import { Heart, Calculator, Image, Hash } from "lucide-react";
import { useNavigate } from "react-router-dom";

const FooterTools = () => {
  const navigate = useNavigate();

  const scrollToBiodataCreator = () => {
    // Find the section by looking for the "Create Your Marriage Biodata" heading
    const biodataCreatorSection = Array.from(document.querySelectorAll('h2'))
      .find(h2 => h2.textContent?.includes('Create Your Marriage Biodata'))?.closest('section');
    if (biodataCreatorSection) {
      biodataCreatorSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const section = Array.from(document.querySelectorAll('h2'))
          .find(h2 => h2.textContent?.includes('Create Your Marriage Biodata'))?.closest('section');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const navigateToPage = (path: string) => {
    navigate(path);
    // Scroll to top after navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <div>
      <h3 className="text-xl font-semibold mb-6 text-red-400">Tools</h3>
      <ul className="space-y-3 flex flex-col items-center sm:items-start">
        <li>
          <button 
            onClick={scrollToBiodataCreator}
            className="text-gray-300 hover:text-white transition-colors text-lg hover:translate-x-1 transform duration-200 flex items-center"
          >
            <Heart className="h-5 w-5 mr-2 text-red-500" />
            Biodata Creator
          </button>
        </li>
        <li>
          <button 
            onClick={() => navigateToPage('/dowry-calculator')}
            className="text-gray-300 hover:text-white transition-colors text-lg hover:translate-x-1 transform duration-200 flex items-center"
          >
            <Calculator className="h-5 w-5 mr-2 text-blue-500" />
            Dowry Calculator
          </button>
        </li>
        <li>
          <button 
            onClick={() => navigateToPage('/partner-compatibility')}
            className="text-gray-300 hover:text-white transition-colors text-lg hover:translate-x-1 transform duration-200 flex items-center"
          >
            <Heart className="h-5 w-5 mr-2 text-purple-500" />
            Partner Compatibility
          </button>
        </li>
        <li>
          <button 
            onClick={() => navigateToPage('/biodata-profile-maker')}
            className="text-gray-300 hover:text-white transition-colors text-lg hover:translate-x-1 transform duration-200 flex items-center"
          >
            <Image className="h-5 w-5 mr-2 text-purple-500" />
            Biodata Profile Maker
          </button>
        </li>
        <li>
          <button 
            onClick={() => navigateToPage('/wedding-hashtag-generator')}
            className="text-gray-300 hover:text-white transition-colors text-lg hover:translate-x-1 transform duration-200 flex items-center"
          >
            <Hash className="h-5 w-5 mr-2 text-pink-500" />
            Wedding Hashtag Generator
          </button>
        </li>
      </ul>
    </div>
  );
};

export default FooterTools;
